import { render } from "./GestioneCampiForm.vue?vue&type=template&id=8fbf9234&scoped=true"
import script from "./GestioneCampiForm.vue?vue&type=script&lang=js"
export * from "./GestioneCampiForm.vue?vue&type=script&lang=js"

import "./GestioneCampiForm.vue?vue&type=style&index=0&id=8fbf9234&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fbf9234"]])

export default __exports__